import React, {useEffect, } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import CountryStatList from '../components/CountryStatList';
import { useSelector, useDispatch } from 'react-redux';
import { getCountriesFetch } from '../redux/state/countryState';
import { filterCountries } from '../utils';


const Country = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation().pathname.split('/')[1];
    const countries = useSelector((state) => state.countries.countries);

    const country = filterCountries(countries, location);

    const handleBackButton = () => {
        navigate('/');
    };

    useEffect(() => {
        dispatch(getCountriesFetch());
    }, [dispatch]);

    return <StyledCountry>
        {country && <>
            <img src={country.countryInfo.flag} alt="" />
            <h1>{country.country}</h1>
            <button className='button' onClick={handleBackButton}>Back</button>
            <CountryStatList country={country} /> 
        </>
        }
    </StyledCountry>;
};

const StyledCountry = styled.div`
    padding: 4rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 80px);

    > h1 {
        margin-top: 2rem;
        font-size: 3rem;
        font-weight: 700;
        background: ${({ theme }) => theme.gradient};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-align: center;
    }

    img {
        width: 200px;
        height: 150px;
        object-fit: cover;
        border-radius: 12px;
        box-shadow: ${({ theme }) => theme.cardShadow};
        border: 3px solid ${({ theme }) => theme.cardBg};
    }

    .button {
        margin-bottom: 2rem;
    }

    hr {
        width: 90%;
        margin: 3rem auto;
        border: none;
        height: 1px;
        background: linear-gradient(
            to right,
            transparent,
            ${({ theme }) => theme.textSecondary}40,
            transparent
        );
    }
`;

export default Country;
